
import PropTypes from "prop-types";

// @mui material components
import Grid from "@mui/material/Grid";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

// Soft UI Dashboard React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import PageLayout from "examples/LayoutContainers/PageLayout";

// Authentication layout components
import Footer from "layouts/authentication/components/Footer";
import ifblogo from "../../../../assets/images/anmol_logo_transparent.png"
import "./style.css"

function CoverLayout({ color, header, title, description, image, top, children }) {
  return (
    <PageLayout background="white">
  <div
  style={{
    backgroundColor: 'rgb(221,51,51)',
    padding: '5px 20px',
    position: 'fixed',
    top: 0,
    zIndex: 1000,
    width: '100%',
  }}
>
  <div
    className="link-container"
    style={{
      display: 'flex',
      alignItems: 'center',
      padding: '5px',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    }}
  >
    <div className="link-item">
      <a href="/vendor/validation">Vendor Registration</a>
    </div>
    <div className="link-item">
      <a href="/customer/validation">Customer Registration</a>
    </div>
    <div className="link-item">
      <a href="/vendor/edit/validation">Vendor Re-KYC</a>
    </div>
    <div className="link-item">
      <a href="/customer/edit/validation">Customer Re-KYC</a>
    </div>
  </div>
</div>

      <Grid
        container
        justifyContent="center"
        sx={{
          minHeight: "75vh",
          margin: 0,
        }}
      >
        <Grid item xs={11} sm={8} md={5} xl={3}>
          
          <SoftBox 
          sx={{
            display:"flex",
            flexDirection: "column",
            justifyContent:"center",
            height:"100vh"
          }}

          >
              {/* <img src={ifblogo} style={{marginLeft:25}}/> */}

             

            <SoftBox pt={2} px={3}>
              {!header ? (
                <>
                 
                  <SoftBox mb={1}>
                    <SoftTypography variant="h3" fontWeight="bold" color='error' textGradient>
                      {title}
                    </SoftTypography>
                  </SoftBox>
                  <SoftTypography variant="body2" fontWeight="regular" color="text">
                    {description}
                  </SoftTypography>
                </>
              ) : (
                header
              )}
            </SoftBox>
            <SoftBox p={3}>{children}</SoftBox>
          </SoftBox>
        </Grid>
        <Grid item xs={12} md={5}>
          <SoftBox
            height="100%"
            display={{ xs: "none", md: "block" }}
            position="relative"
            right={{ md: "-6rem", xl: "-4rem" }}
            mr={-8}
            sx={{
              // transform: "skewX(-10deg)",
              overflow: "hidden",
              borderBottomLeftRadius: ({ borders: { borderRadius } }) => borderRadius.lg,
            }}
          >
            <SoftBox
              ml={0}
              mt={4} 
              top="4rem"
      width="90%"
      height="90%"
              sx={{
                backgroundImage: `url(${image})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                // transform: "skewX(12deg)",
              }}
            />
          </SoftBox>
        </Grid>
      </Grid>
      {/* <Footer /> */}
    </PageLayout>
  );
}

// Setting default values for the props of CoverLayout
CoverLayout.defaultProps = {
  header: "",
  title: "",
  description: "",
  color: "info",
  top: 20,
};

// Typechecking props for the CoverLayout
CoverLayout.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "secondary",
    "info",
    "success",
    "warning",
    "error",
    "dark",
    "light",
  ]),
  header: PropTypes.node,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string.isRequired,
  top: PropTypes.number,
  children: PropTypes.node.isRequired,
};

export default CoverLayout;
